var _circle, _path, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgType2Connector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3333,
    cy: 12,
    r: 10.5,
    stroke: "param(outline) #fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.8333 12C19.8333 16.1421 16.4754 19.5 12.3333 19.5C8.19118 19.5 4.83331 16.1421 4.83331 12C4.83331 9.82705 5.75681 7.87038 7.23424 6.5H17.4324C18.9098 7.87038 19.8333 9.82705 19.8333 12Z",
    stroke: "param(outline) #fff"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3333,
    cy: 15.5,
    r: 1,
    fill: "param(outline) #fff"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10.3333,
    cy: 9.5,
    r: 1,
    fill: "param(outline) #fff"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3333,
    cy: 15.5,
    r: 1,
    fill: "param(outline) #fff"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 14.3333,
    cy: 9.5,
    r: 1,
    fill: "param(outline) #fff"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 8.33331,
    cy: 12.5,
    r: 1,
    fill: "param(outline) #fff"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.3333,
    cy: 12.5,
    r: 1,
    fill: "param(outline) #fff"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.3333,
    cy: 12.5,
    r: 1,
    fill: "param(outline) #fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgType2Connector);
export default __webpack_public_path__ + "static/media/type2_connector.c817bb0316c1321069342bbcdd99dfb2.svg";
export { ForwardRef as ReactComponent };